import { useAuth } from "../../auth/hooks";
import {
  Filter,
  OrderByType,
  useGenericAPI,
  useSingleGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import {
  ChargingSession,
  ChargingSessionPatch,
} from "../types/chargingSession.types";
import { BASE_URL_CHARGING_SESSION_ADMIN, } from "../service/chargingSessionAPI";

import useQueryURL from "../../../common/hooks/useQueryURL";


export interface Option {
  pageSize?: number;
  orderBy?: OrderByType<ChargingSession>;
  filter?: Filter<ChargingSessionPatch>;
  hookId?: string;
}

export default function useChargingSessionAdmin(options?: Option) {
  useAuth().setHeaderAuthToRequest();

  const query = useGenericAPI<
    ChargingSession,
    ChargingSessionPatch,
    ChargingSessionPatch
  >({
    baseURL: BASE_URL_CHARGING_SESSION_ADMIN,
    pageSize: options?.pageSize || 10,
    orderBy: options?.orderBy || "-cs_create_at",
    APIname: "chargingSession"+(options?.hookId ? `-${options.hookId}` : ""),
    preFilter: options?.filter,
  });

  return {
    getAllChargingSession: query.getAllQuery,
  };
}

export function useSingleChargingSessionAdmin(id?: string) {
  useAuth().setHeaderAuthToRequest();

  const { getQueryValue } = useQueryURL();

  const idFromURL = getQueryValue("chargingSessionId");

 
  const idFound = id || idFromURL;
  if (!idFound) {
    console.error("chargingSessionId is required");
  }


  const {singleQuery} = useSingleGenericAPI<ChargingSession, ChargingSessionPatch>({
    baseURL: BASE_URL_CHARGING_SESSION_ADMIN,
    APIname: "chargingSessionSingle",
    id: idFound || undefined
  });

  return {
    singleChargingSessionQuery: singleQuery,
    idFound,
    chargingSessionId: idFound
  };
}

export type sumCS = {
  total: number;
}

export const  useChargingSessionSumAnalysis = (attribute: keyof ChargingSession,config: {

  preFilter?: Filter<ChargingSessionPatch>;
}) => {

  const {getAllQuery} = useGenericAPI<sumCS, null, ChargingSessionPatch>({
    baseURL: BASE_URL_CHARGING_SESSION_ADMIN+"/analysis/sum/"+attribute,
    APIname: "chargingSessionSumAnalysis"+attribute,
    preFilter: config?.preFilter,
    ...config
  })

  return {
    sumChargingSessionAnalysisQuery: getAllQuery,
  };
}